import { createFilter } from '../../../utils/columnFilters/createFilter';

export const postalCodeFilter = (searchInput, t) =>
  createFilter({
    dataIndex: 'address',
    placeHolder: 'pensioners.show.place_holders.search_by_postal_code',
    filterFunction: (value, record, dataIndex) =>
      record?.[dataIndex]?.postal_code
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    searchInput,
    t
  });
